import { addProp } from "@pnp/odata";
import { _User } from "../users/types.js";
import { Outlook } from "./types.js";
addProp(_User, "outlook", Outlook, "outlook");
//# sourceMappingURL=users.js.map